import React, { useEffect, useState } from 'react';

import { ROLE_METIER_ASSOCIATION } from 'utils/droitsEtRoles.constant';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setEtapeActive } from 'store/etapes/etapesActions';
import { reinitialiseAPI, getAPI } from 'store/apiReducer';
import { IndicateurEtapes, Button, Row, Col } from '@si-armes/dsfr-react';
import usagerClientReducer from 'store/usagerReducer';
import { TITRES } from 'constants/titreDetention.constants';
import useToaster from 'hooks/useToaster';
import {
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from 'components/FeatureFlipping/featureFlipping.func';
import {
    API_FORM_TITRE_DETENTION_URL,
    CONTEXT_FORM_TITRE_DETENTION,
} from 'constants/apiUrls.constants';
import { useHistory } from 'react-router';
import CreerTitreDetentionEtape1 from './CreerTitreDetentionEtape1';
import CreerTitreDetentionEtape2 from './CreerTitreDetentionEtape2';
import CreerTitreDetentionPersonnePhysiqueEtape2 from './metier-association/CreerTitreDetentionPersonnePhysiqueEtape2';
import CreerTitreDetentionPersonneMoraleEtape2 from './metier-association/CreerTitreDetentionPersonneMoraleEtape2';

const CreerTitreDetention = () => {
    const history = useHistory();
    const { type } = useParams();
    const { etapeActive } = useSelector((state) => state.etapes.etapes); // TODO supprimer le dernier etape
    const dispatch = useDispatch();
    // SIAR-6341 : choix de la catégorie (A/B ou C) pour les Essais industriels.
    // null = choix non encore effectué, false = Catégorie A/B, true = Catégorie C.
    const [isCategorieC, setIsCategorieC] = useState(null);
    const etapes = [
        { key: 1, titre: 'Identité du demandeur' },
        { key: 2, titre: "Demande d'autorisation" },
    ];

    // initilaiser l'étape à la creation de composant
    useEffect(() => {
        dispatch(setEtapeActive(1));
    }, []);

    // Charger le formulaire et verfier les accées
    const { data: form, isLoading } = useSelector((state) => state.titreDetention.form);

    const { data: dataUsager } = useSelector((state) => state?.profil?.usager);

    const roles = dataUsager?.roles || [];

    const { data: dataInfoPerso } = useSelector(
        (state) => state.monCompte.recupererInformationsPersonnelles,
    );

    const hasPersonneMorale = dataInfoPerso?.informationsMetiersAssociations?.hasPersonneMorale;
    const isMineurNonEmancipe = dataInfoPerso?.mineurEmancipe === false;

    const { triggerToaster, closeToaster } = useToaster();
    const { data: featureFlipping } = useSelector((state) => state.featureFlipping);

    // Charger le formulaire dynamic depuis API
    useEffect(() => {
        dispatch(
            getAPI(
                usagerClientReducer,
                API_FORM_TITRE_DETENTION_URL.replace(':type', type),
                CONTEXT_FORM_TITRE_DETENTION,
            ),
        );
        return () => {
            dispatch(reinitialiseAPI(CONTEXT_FORM_TITRE_DETENTION));
        };
    }, [type]);

    useEffect(() => {
        // Après le dispatch qui interroge l'API si le toaster n'a pas été lancé on le trigger
        if (
            isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) &&
            !roles?.includes(ROLE_METIER_ASSOCIATION)
        ) {
            if (isLoading) {
                triggerToaster();
            } else {
                closeToaster();
            }
        }
    }, [isLoading, featureFlipping]);

    const renderIndicateurEtapes = () => (
        <IndicateurEtapes
            etapeEnCours={etapeActive}
            nombreEtapes={2}
            titreEtapeEnCours={etapes.find((etape) => etape.key === etapeActive).titre}
            titreProchaineEtape={
                etapeActive === 1 ? etapes.find((etape) => etape.key === 2).titre : null
            }
        />
    );

    const renderErrorContent = () => (
        <Row gutters className="margin-top-md">
            <Col lg={6}>
                <Button name="etapePrecedente" variant="secondary" onClick={history.goBack}>
                    Retour
                </Button>
            </Col>
        </Row>
    );

    if (form && !form.erreur && roles?.includes(ROLE_METIER_ASSOCIATION)) {
        return (
            <>
                <h1>{TITRES[type]}</h1>
                {renderIndicateurEtapes()}
                <div className="segment transfertArmes">
                    {etapeActive === 1 && (
                        <CreerTitreDetentionEtape1
                            type={type}
                            isCategorieC={isCategorieC}
                            setIsCategorieC={setIsCategorieC}
                        />
                    )}
                    {etapeActive === 2 &&
                        (hasPersonneMorale ? (
                            <CreerTitreDetentionPersonneMoraleEtape2
                                type={type}
                                defaultValues={form}
                                isCategorieC={isCategorieC}
                            />
                        ) : (
                            <CreerTitreDetentionPersonnePhysiqueEtape2
                                type={type}
                                defaultValues={form}
                            />
                        ))}
                </div>
            </>
        );
    }

    return (
        <>
            <h1>{TITRES[type]}</h1>
            {form && !form.erreur ? (
                <>
                    {renderIndicateurEtapes()}
                    <div className="segment transfertArmes">
                        {etapeActive === 1 && (
                            <CreerTitreDetentionEtape1
                                type={type}
                                isCategorieC={isCategorieC}
                                setIsCategorieC={setIsCategorieC}
                            />
                        )}
                        {etapeActive === 2 && (
                            <CreerTitreDetentionEtape2
                                type={type}
                                defaultValues={form}
                                isMineurNonEmancipe={isMineurNonEmancipe}
                            />
                        )}
                    </div>
                </>
            ) : (
                renderErrorContent()
            )}
        </>
    );
};

export default CreerTitreDetention;
